import { useEffect, useState } from "react";

const COOKIE_CONSENT_KEY = "miboard-cookie-consent";

const buttonStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 44,
  padding: "0 20px",
  borderRadius: 8,
  border: "1px solid #05a8ff",
  background: "#05a8ff",
  color: "white",
  fontFamily: "var(--ui-font, Assistant, sans-serif)",
  fontSize: 16,
  fontWeight: 600,
  textDecoration: "none",
  boxSizing: "border-box" as const,
};

const outlineButton = {
  ...buttonStyle,
  background: "white",
  color: "#004fc9",
};

export const LandingPage = () => {
  const [cookieConsent, setCookieConsent] = useState(() =>
    localStorage.getItem(COOKIE_CONSENT_KEY),
  );
  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const saveCookieConsent = (choice: "essential" | "all") => {
    localStorage.setItem(COOKIE_CONSENT_KEY, choice);
    setCookieConsent(choice);
    if (choice === "all") {
      window.location.reload();
    }
  };

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");
    const previous = {
      htmlOverflow: html.style.overflow,
      bodyOverflow: body.style.overflow,
      rootHeight: root?.style.height || "",
      rootMinHeight: root?.style.minHeight || "",
    };
    html.style.overflow = "auto";
    body.style.overflow = "auto";
    if (root) {
      root.style.height = "auto";
      root.style.minHeight = "100%";
    }
    return () => {
      html.style.overflow = previous.htmlOverflow;
      body.style.overflow = previous.bodyOverflow;
      if (root) {
        root.style.height = previous.rootHeight;
        root.style.minHeight = previous.rootMinHeight;
      }
    };
  }, []);

  return (
    <main
      className="miboard-landing-shell"
      style={{
        minHeight: "100vh",
        color: "#1e1e1e",
        background: "#f8fbfc",
        fontFamily: "var(--ui-font, Assistant, sans-serif)",
      }}
    >
      <header
        className="miboard-landing-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 24,
          maxWidth: 1180,
          margin: "0 auto",
          padding: "20px 28px",
        }}
      >
        <a
          href="/"
          style={{
            color: "#05a8ff",
            fontSize: 26,
            fontWeight: 700,
            letterSpacing: "-.03em",
            textDecoration: "none",
          }}
        >
          MiBoard
        </a>
        <nav
          className="miboard-landing-nav"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 22,
            fontSize: 15,
          }}
        >
          <a
            href="#recursos"
            onClick={(event) => {
              event.preventDefault();
              scrollToSection("recursos");
            }}
            style={{ color: "#55717b", textDecoration: "none" }}
          >
            Recursos
          </a>
          <a
            href="#planos"
            onClick={(event) => {
              event.preventDefault();
              scrollToSection("planos");
            }}
            style={{ color: "#55717b", textDecoration: "none" }}
          >
            Planos
          </a>
          <a href="/app/login" style={outlineButton}>
            Entrar
          </a>
        </nav>
      </header>

      <section
        className="miboard-landing-hero"
        style={{
          maxWidth: 1180,
          margin: "0 auto",
          padding: "82px 28px 96px",
          display: "grid",
          gridTemplateColumns: "minmax(0, 1fr) minmax(360px, .9fr)",
          alignItems: "center",
          gap: 64,
        }}
      >
        <div className="miboard-landing-heroCopy">
          <p
            style={{
              color: "#004fc9",
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: ".12em",
              margin: 0,
            }}
          >
            PENSAR. PEDIR. GERAR.
          </p>
          <h1
            style={{
              maxWidth: 650,
              margin: "18px 0",
              color: "#1e1e1e",
              fontSize: "clamp(44px, 6vw, 74px)",
              lineHeight: 1.02,
              letterSpacing: "-.055em",
            }}
          >
            É só descrever a ideia e a IA dá vida ao seu projeto.
          </h1>
          <p
            style={{
              maxWidth: 560,
              margin: "0 0 26px",
              color: "#55717b",
              fontSize: 20,
              lineHeight: 1.5,
            }}
          >
            Em dois cliques, sua ideia já vira um diagrama.
          </p>
          <div
            className="miboard-landing-heroActions"
            style={{ display: "flex", flexWrap: "wrap", gap: 12 }}
          >
            <a href="/app/signup" style={buttonStyle}>
              Começar grátis
            </a>
            <a
              href="#planos"
              onClick={(event) => {
                event.preventDefault();
                scrollToSection("planos");
              }}
              style={outlineButton}
            >
              Ver planos
            </a>
          </div>
          <p style={{ marginTop: 18, color: "#78909a", fontSize: 13 }}>
            Sem cartão de crédito · Plano Basic gratuito
          </p>
        </div>
        <div
          className="miboard-landing-heroArt"
          style={{
            minHeight: 360,
            padding: 22,
            border: "1px solid #d8e8ed",
            borderRadius: 18,
            background: "white",
            boxShadow: "0 18px 50px #05a8ff1f",
            transform: "rotate(1deg)",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 7,
              paddingBottom: 16,
              borderBottom: "1px solid #edf3f5",
            }}
          >
            <i
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#f28b82",
              }}
            />
            <i
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#fbbc04",
              }}
            />
            <i
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#05a8ff",
              }}
            />
          </div>
          <div
            style={{
              margin: "28px 10px 10px",
              display: "grid",
              gap: 16,
            }}
          >
            <div
              style={{
                border: "1px solid #d9e9ee",
                borderRadius: 16,
                background: "#f8fbff",
                padding: 16,
                boxShadow: "inset 0 0 0 1px rgba(5, 168, 255, 0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  marginBottom: 10,
                }}
              >
                <strong style={{ color: "#004fc9", fontSize: 16 }}>
                  Peça para a IA
                </strong>
                <span
                  style={{
                    fontSize: 12,
                    color: "#6f8590",
                    background: "#eef6ff",
                    borderRadius: 999,
                    padding: "4px 10px",
                  }}
                >
                  Prompt
                </span>
              </div>
              <div
                style={{
                  display: "grid",
                  gap: 10,
                  border: "1px solid #cfe6ff",
                  background: "white",
                  borderRadius: 14,
                  padding: 14,
                }}
              >
                <div
                  style={{
                    color: "#9aa8b1",
                    fontSize: 13,
                    lineHeight: 1.4,
                  }}
                >
                  Ex: “Crie um fluxo de checkout com landing, plano, pagamento e
                  sucesso.”
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 10,
                    alignItems: "center",
                    background: "#f4f9ff",
                    borderRadius: 12,
                    padding: "10px 12px",
                  }}
                >
                  <span style={{ color: "#004fc9", fontWeight: 700 }}>
                    Gerar diagrama
                  </span>
                  <span
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: "50%",
                      background: "#05a8ff",
                      color: "white",
                      display: "grid",
                      placeItems: "center",
                      fontSize: 18,
                    }}
                  >
                    ↗
                  </span>
                </div>
              </div>
            </div>

            <div
              style={{
                border: "2px dashed #8ccfff",
                borderRadius: 16,
                background:
                  "linear-gradient(180deg, rgba(255,255,255,.96) 0%, rgba(244,249,255,.96) 100%)",
                padding: 18,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  marginBottom: 16,
                }}
              >
                <div>
                  <strong style={{ fontSize: 20, color: "#004fc9" }}>
                    Diagrama gerado
                  </strong>
                  <p style={{ margin: "4px 0 0", color: "#55717b" }}>
                    A IA transforma o pedido em fluxo visual.
                  </p>
                </div>
                <span
                  style={{
                    fontSize: 12,
                    color: "#004fc9",
                    background: "#eaf3ff",
                    borderRadius: 999,
                    padding: "5px 10px",
                    fontWeight: 700,
                  }}
                >
                  IA ativa
                </span>
              </div>

              <div
                className="miboard-landing-handdrawn-flow"
                style={{
                  position: "relative",
                  minHeight: 170,
                  background: "white",
                  borderRadius: 14,
                  border: "1px solid #d9e9ee",
                  padding: 18,
                  overflow: "hidden",
                }}
              >
                <svg
                  viewBox="0 0 620 245"
                  role="img"
                  aria-label="Fluxograma desenhado à mão"
                  style={{ width: "100%", height: "100%", display: "block" }}
                >
                  <g
                    fill="none"
                    stroke="#263945"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                  >
                    <path d="M310 9 v24" />
                    <path d="M310 33 l-5 -9 M310 33 l5 -9" />
                    <rect x="214" y="35" width="192" height="43" rx="2" transform="rotate(-1 214 35)" />
                    <path d="M310 79 v19" />
                    <path d="M310 98 l-5 -9 M310 98 l5 -9" />
                    <path d="M310 99 L374 148 L310 198 L246 148 Z" />
                    <path d="M274 178 L175 216" />
                    <path d="M175 216 l11 -1 M175 216 l7 -8" />
                    <path d="M346 178 L445 216" />
                    <path d="M445 216 l-7 -8 M445 216 l-11 -1" />
                    <rect x="76" y="207" width="136" height="28" rx="1" transform="rotate(-1 76 207)" />
                    <rect x="408" y="207" width="136" height="28" rx="1" transform="rotate(1 408 207)" />
                    <path d="M544 220 C590 215 582 94 468 70" />
                    <path d="M468 70 l10 -1 M468 70 l7 8" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="miboard-landing-section"
        style={{ padding: "76px 28px", background: "#eef8ff" }}
      >
        <div
          className="miboard-landing-education"
          style={{
            maxWidth: 1080,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) minmax(340px, .9fr)",
            gap: 48,
            alignItems: "center",
          }}
        >
          <div>
            <p
              style={{
                margin: 0,
                color: "#004fc9",
                fontSize: 12,
                fontWeight: 800,
                letterSpacing: ".14em",
              }}
            >
              PARA PROFESSORES E EDUCADORES
            </p>
            <h2
              style={{
                maxWidth: 620,
                margin: "14px 0",
                fontSize: 42,
                lineHeight: 1.08,
                letterSpacing: "-.045em",
              }}
            >
              Transforme a aula em um quadro interativo.
            </h2>
            <p
              style={{
                maxWidth: 600,
                margin: "0 0 24px",
                color: "#55717b",
                fontSize: 18,
                lineHeight: 1.6,
              }}
            >
              Explique conceitos visualmente, construa mapas mentais com a
              turma, organize exercícios e deixe cada aula salva para retomar
              quando quiser.
            </p>
            <a href="/app/signup" style={buttonStyle}>
              Criar um quadro para minha aula
            </a>
          </div>
          <div
            style={{
              display: "grid",
              gap: 12,
              padding: 22,
              border: "1px solid #cde7f7",
              borderRadius: 22,
              background: "#ffffff",
              boxShadow: "0 18px 42px rgba(0, 79, 201, .09)",
            }}
          >
            {[
              ["01", "Apresente", "Organize o conteúdo da aula de forma visual."],
              ["02", "Construa junto", "Use o quadro para discutir ideias e resolver exercícios."],
              ["03", "Retome depois", "Mantenha o material salvo para a próxima turma."],
            ].map(([step, title, text]) => (
              <div
                key={step}
                style={{
                  display: "grid",
                  gridTemplateColumns: "38px 1fr",
                  gap: 12,
                  alignItems: "start",
                  padding: 12,
                  borderRadius: 14,
                  background: "#f7fbfe",
                }}
              >
                <span
                  style={{
                    display: "grid",
                    width: 34,
                    height: 34,
                    placeItems: "center",
                    borderRadius: 10,
                    background: "#dff0ff",
                    color: "#004fc9",
                    fontSize: 13,
                    fontWeight: 800,
                  }}
                >
                  {step}
                </span>
                <div>
                  <h3 style={{ margin: "0 0 4px", fontSize: 17 }}>{title}</h3>
                  <p style={{ margin: 0, color: "#55717b", lineHeight: 1.45 }}>
                    {text}
                  </p>
                </div>
              </div>
            ))}
            <div
              style={{
                position: "relative",
                minHeight: 184,
                overflow: "hidden",
                borderRadius: 14,
                background: "#14324a",
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,.08)",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 12,
                  left: 14,
                  display: "flex",
                  gap: 5,
                }}
              >
                {["#ff7d72", "#ffd167", "#75d38a"].map((color) => (
                  <span
                    key={color}
                    style={{ width: 7, height: 7, borderRadius: "50%", background: color }}
                  />
                ))}
              </div>
              <div
                style={{
                  position: "absolute",
                  top: 30,
                  right: 70,
                  bottom: 14,
                  left: 14,
                  borderRadius: 10,
                  background: "#fbfdff",
                  overflow: "hidden",
                }}
              >
                <svg
                  viewBox="0 0 480 220"
                  role="img"
                  aria-label="Diagrama compartilhado durante uma aula online"
                  style={{ width: "100%", height: "100%", display: "block" }}
                >
                  <g
                    fill="none"
                    stroke="#29404f"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.4"
                  >
                    <rect x="44" y="72" width="132" height="78" rx="15" transform="rotate(-2 44 72)" />
                    <ellipse cx="274" cy="71" rx="55" ry="28" transform="rotate(2 274 71)" />
                    <rect x="326" y="133" width="110" height="54" rx="8" transform="rotate(1 326 133)" />
                    <path d="M177 102 C201 79 215 74 219 74" />
                    <path d="M219 74 l-9 -2 M219 74 l-5 8" />
                    <path d="M303 88 C327 104 344 121 361 133" />
                    <path d="M361 133 l-9 -1 M361 133 l-4 8" />
                    <path d="M173 145 C220 173 270 173 324 158" />
                    <path d="M324 158 l-8 -4 M324 158 l-2 9" />
                    <path d="M71 99 C99 95 127 99 148 96" strokeWidth="1.8" />
                    <path d="M71 119 C108 115 132 120 152 117" strokeWidth="1.8" />
                  </g>
                </svg>
              </div>
              <div
                style={{
                  position: "absolute",
                  right: 13,
                  bottom: 15,
                  display: "grid",
                  width: 66,
                  height: 76,
                  placeItems: "center",
                  border: "2px solid rgba(255,255,255,.8)",
                  borderRadius: 10,
                  background: "linear-gradient(160deg, #81cfff 0%, #3d83cc 100%)",
                }}
              >
                <div
                  style={{
                    width: 25,
                    height: 25,
                    marginTop: 10,
                    borderRadius: "50%",
                    background: "#f3c6a5",
                  }}
                />
                <div
                  style={{
                    width: 42,
                    height: 28,
                    borderRadius: "20px 20px 7px 7px",
                    background: "#173e67",
                  }}
                />
              </div>
              <span
                style={{
                  position: "absolute",
                  top: 11,
                  right: 13,
                  color: "#d8efff",
                  fontSize: 11,
                  fontWeight: 700,
                }}
              >
                AULA AO VIVO
              </span>
            </div>
          </div>
        </div>
      </section>

      <section
        className="miboard-landing-section"
        id="recursos"
        style={{
          padding: "92px 28px",
          background:
            "linear-gradient(180deg, #ffffff 0%, #f8fcff 52%, #ffffff 100%)",
        }}
      >
        <div style={{ maxWidth: 1140, margin: "0 auto" }}>
          <div
            className="miboard-landing-featureIntro"
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1.05fr) minmax(0, .95fr)",
              gap: 30,
              alignItems: "end",
              marginBottom: 28,
            }}
          >
            <div>
              <p
                style={{
                  color: "#004fc9",
                  fontWeight: 800,
                  letterSpacing: ".14em",
                  fontSize: 12,
                }}
              >
                FEITO PARA O FLUXO REAL
              </p>
              <h2
                style={{
                  maxWidth: 720,
                  margin: "12px 0 14px",
                  fontSize: 42,
                  lineHeight: 1.05,
                  letterSpacing: "-.05em",
                }}
              >
                Tudo o que sua equipe precisa para sair do rascunho.
              </h2>
              <p
                style={{
                  maxWidth: 640,
                  margin: 0,
                  color: "#55717b",
                  fontSize: 18,
                  lineHeight: 1.6,
                }}
              >
                O MiBoard organiza o trabalho visual, reaproveita peças entre
                projetos e mantém o time alinhado sem espalhar a informação em
                várias ferramentas.
              </p>
            </div>
            <div
              style={{
                justifySelf: "start",
                padding: "16px 18px",
                borderRadius: 18,
                border: "1px solid #dcecf8",
                background: "#ffffff",
                boxShadow: "0 18px 45px rgba(0,79,201,0.08)",
                display: "grid",
                gap: 10,
                minWidth: 280,
              }}
            >
              <div
                style={{
                  color: "#004fc9",
                  fontWeight: 700,
                  fontSize: 12,
                  letterSpacing: ".12em",
                }}
              >
                O QUE VOCÊ GANHA
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                }}
              >
                {[
                  "Mais clareza",
                  "Menos retrabalho",
                  "Reaproveitamento",
                  "Organização",
                ].map((pill) => (
                  <span
                    key={pill}
                    style={{
                      padding: "8px 12px",
                      borderRadius: 999,
                      background: "#eff7ff",
                      color: "#004fc9",
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    {pill}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div
            className="miboard-landing-featureGrid"
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1.2fr) minmax(0, .8fr)",
              gap: 18,
            }}
          >
            <article
              style={{
                border: "1px solid #d9e9ee",
                borderRadius: 22,
                background: "linear-gradient(180deg, #ffffff 0%, #f9fcff 100%)",
                boxShadow: "0 18px 42px rgba(17, 44, 70, 0.06)",
                overflow: "hidden",
                padding: 24,
                minHeight: 340,
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 18,
                  gap: 12,
                }}
              >
                <div>
                  <span
                    style={{
                      color: "#05a8ff",
                      fontWeight: 800,
                      fontSize: 12,
                      letterSpacing: ".16em",
                    }}
                  >
                    01
                  </span>
                  <h3 style={{ margin: "8px 0 6px", fontSize: 24 }}>
                    Painéis visuais
                  </h3>
                  <p style={{ color: "#55717b", lineHeight: 1.6, margin: 0 }}>
                    Desenhe processos, mapas e decisões com blocos prontos e
                    edição sem atrito.
                  </p>
                </div>
                <div
                  style={{
                    padding: "10px 14px",
                    borderRadius: 999,
                    background: "#eff7ff",
                    color: "#004fc9",
                    fontWeight: 700,
                    fontSize: 13,
                    whiteSpace: "nowrap",
                  }}
                >
                  Editor + IA
                </div>
              </div>
              <div
                className="miboard-landing-handdrawn-diagram"
                style={{
                  position: "relative",
                  height: 210,
                  borderRadius: 20,
                  border: "1px dashed #b8d9ff",
                  background:
                    "linear-gradient(180deg, #ffffff 0%, #f5fbff 100%)",
                  overflow: "hidden",
                }}
              >
                <svg
                  viewBox="0 0 640 270"
                  role="img"
                  aria-label="Exemplo de um diagrama desenhado à mão"
                  style={{ width: "100%", height: "100%", display: "block" }}
                >
                  <g
                    fill="none"
                    stroke="#263945"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.6"
                  >
                    <path d="M321 58 C286 30 249 29 211 55" />
                    <path d="M211 55 l13 -3 M211 55 l7 10" />
                    <path d="M347 58 C391 31 444 34 490 72" />
                    <path d="M490 72 l-3 -13 M490 72 l-12 -4" />
                    <path d="M326 104 C297 132 265 153 217 166" />
                    <path d="M217 166 l12 4 M217 166 l7 -10" />
                    <path d="M350 105 C383 132 421 145 476 146" />
                    <path d="M476 146 l-10 -8 M476 146 l-11 7" />
                    <rect x="42" y="82" width="167" height="105" rx="22" transform="rotate(-2 42 82)" />
                    <ellipse cx="334" cy="82" rx="57" ry="30" transform="rotate(2 334 82)" />
                    <ellipse cx="521" cy="151" rx="64" ry="31" transform="rotate(-3 521 151)" />
                    <path d="M68 111 C96 106 124 109 147 107" strokeWidth="2" />
                    <path d="M68 132 C118 128 148 133 176 129" strokeWidth="2" />
                    <path d="M68 153 C101 149 130 153 157 150" strokeWidth="2" />
                    <path d="M304 82 C317 76 341 76 362 81" strokeWidth="2" />
                    <path d="M493 151 C510 145 535 146 552 151" strokeWidth="2" />
                  </g>
                </svg>
              </div>
            </article>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 18,
              }}
            >
              {[
                [
                  "02",
                  "Biblioteca pessoal",
                  "Guarde componentes, trechos e padrões para reutilizar em novos painéis.",
                  "Reutilize sem refazer",
                ],
                [
                  "03",
                  "Compartilhar",
                  "Compartilhe o contexto do trabalho e alinhe o time mais rápido.",
                  "Menos ruído",
                ],
                [
                  "04",
                  "Busca e organização",
                  "Localize, duplique e renomeie com agilidade sem perder o histórico.",
                  "Encontre rápido",
                ],
              ].map(([number, title, text, badge]) => (
                <article
                  key={number}
                  style={{
                    padding: 22,
                    border: "1px solid #d9e9ee",
                    borderRadius: 20,
                    background: "#ffffff",
                    boxShadow: "0 16px 36px rgba(17, 44, 70, 0.05)",
                    display: "grid",
                    gap: 12,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                      gap: 12,
                    }}
                  >
                    <span
                      style={{
                        color: "#05a8ff",
                        fontWeight: 800,
                        fontSize: 12,
                        letterSpacing: ".16em",
                      }}
                    >
                      {number}
                    </span>
                    <span
                      style={{
                        padding: "7px 11px",
                        borderRadius: 999,
                        background: "#eff7ff",
                        color: "#004fc9",
                        fontSize: 12,
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {badge}
                    </span>
                  </div>
                  <div>
                    <h3 style={{ margin: "0 0 8px", fontSize: 22 }}>{title}</h3>
                    <p style={{ color: "#55717b", lineHeight: 1.6, margin: 0 }}>
                      {text}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section
        className="miboard-landing-section"
        style={{ padding: "88px 28px", background: "#f8fbfc" }}
      >
        <div
          className="miboard-landing-split"
          style={{
            maxWidth: 1080,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "minmax(0, .85fr) minmax(0, 1.15fr)",
            gap: 56,
            alignItems: "center",
          }}
        >
          <div>
            <p
              style={{
                color: "#004fc9",
                fontWeight: 700,
                letterSpacing: ".1em",
              }}
            >
              DO CAOS À CLAREZA
            </p>
            <h2
              style={{
                margin: "12px 0 18px",
                fontSize: 42,
                letterSpacing: "-.04em",
              }}
            >
              Um fluxo simples para cada ideia.
            </h2>
            <p style={{ color: "#55717b", fontSize: 18, lineHeight: 1.6 }}>
              Comece com um rascunho, transforme-o em um painel reutilizável e
              convide as pessoas certas para construir junto. O MiBoard mantém
              cada painel salvo e pronto para o próximo passo.
            </p>
            <a href="/app/signup" style={{ ...buttonStyle, marginTop: 12 }}>
              Criar meu primeiro painel
            </a>
          </div>
          <div
            className="miboard-landing-stepGrid"
            style={{ display: "grid", gap: 14 }}
          >
            {[
              [
                "01",
                "Capture",
                "Rabisque uma hipótese, um mapa mental ou um fluxo.",
              ],
              [
                "02",
                "Conecte",
                "Organize os elementos, links e referências em um só lugar.",
              ],
              [
                "03",
                "Compartilhe",
                "Apresente a decisão e continue evoluindo com seu time.",
              ],
            ].map(([step, title, text]) => (
              <div
                key={step}
                style={{
                  display: "grid",
                  gridTemplateColumns: "46px 1fr",
                  gap: 16,
                  alignItems: "start",
                  padding: 18,
                  border: "1px solid #d9e9ee",
                  borderRadius: 14,
                  background: "white",
                }}
              >
                <span
                  style={{
                    display: "grid",
                    placeItems: "center",
                    width: 38,
                    height: 38,
                    borderRadius: 10,
                    background: "#dff0ff",
                    color: "#004fc9",
                    fontWeight: 700,
                  }}
                >
                  {step}
                </span>
                <div>
                  <h3 style={{ margin: "0 0 5px" }}>{title}</h3>
                  <p style={{ margin: 0, color: "#55717b", lineHeight: 1.45 }}>
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="miboard-landing-section"
        style={{ padding: "88px 28px", background: "white" }}
      >
        <div style={{ maxWidth: 1080, margin: "0 auto" }}>
          <div
            className="miboard-landing-twoCards"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: 18,
            }}
          >
            <article
              style={{
                padding: 28,
                borderRadius: 16,
                background: "linear-gradient(180deg, #0b2f54 0%, #103b7a 100%)",
                color: "white",
              }}
            >
              <span style={{ color: "#8ccfff", fontWeight: 700 }}>ACELERE</span>
              <h2
                style={{
                  margin: "14px 0 12px",
                  fontSize: 30,
                  letterSpacing: "-.03em",
                }}
              >
                IA que transforma pedido em diagrama.
              </h2>
              <p style={{ margin: 0, color: "#dbeeff", lineHeight: 1.55 }}>
                Você escreve a intenção, a IA monta o esqueleto visual e o
                painel já nasce pronto para editar, detalhar e apresentar.
              </p>
            </article>
            <article
              style={{
                padding: 28,
                border: "1px solid #d9e9ee",
                borderRadius: 16,
                background: "#f8fbfc",
              }}
            >
              <span style={{ color: "#004fc9", fontWeight: 700 }}>
                CONTINUE
              </span>
              <h2
                style={{
                  margin: "14px 0 12px",
                  fontSize: 30,
                  letterSpacing: "-.03em",
                }}
              >
                Seu trabalho acompanha você.
              </h2>
              <p style={{ margin: 0, color: "#55717b", lineHeight: 1.55 }}>
                Painéis, workspaces e compatibilidade com arquivos
                para importar, exportar e retomar de onde parou.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section
        className="miboard-landing-section"
        id="planos"
        style={{ padding: "82px 28px", background: "#f4f9ff" }}
      >
        <div style={{ maxWidth: 860, margin: "0 auto", textAlign: "center" }}>
          <p
            style={{ color: "#004fc9", fontWeight: 700, letterSpacing: ".1em" }}
          >
            PLANOS
          </p>
          <h2
            style={{
              margin: "12px 0 38px",
              fontSize: 42,
              letterSpacing: "-.04em",
            }}
          >
            Comece no seu ritmo.
          </h2>
          <div
            className="miboard-landing-pricingGrid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
              gap: 18,
              textAlign: "left",
            }}
          >
            <article
              style={{
                padding: 30,
                border: "1px solid #d9e9ee",
                borderRadius: 16,
                background: "white",
              }}
            >
              <h3>Basic</h3>
              <p style={{ color: "#55717b" }}>
                Para experimentar e organizar o essencial.
              </p>
              <strong style={{ fontSize: 34 }}>Grátis</strong>
              <p>Acesso limitado às features principais.</p>
              <a
                href="/app/checkout?plan=premium"
                style={{ ...outlineButton, width: "100%", marginTop: 18 }}
              >
                Começar grátis
              </a>
            </article>
            <article
              style={{
                padding: 30,
                border: "2px solid #05a8ff",
                borderRadius: 16,
                background: "white",
              }}
            >
              <h3>Premium</h3>
              <p style={{ color: "#55717b" }}>
                Para equipes que precisam de tudo.
              </p>
              <strong style={{ fontSize: 34 }}>
                R$ 9<span style={{ fontSize: 16 }}>/mês</span>
              </strong>
              <p>Ou R$ 57/ano · acesso total.</p>
              <a
                href="/app/checkout"
                style={{ ...buttonStyle, width: "100%", marginTop: 18 }}
              >
                Escolher Premium
              </a>
            </article>
          </div>
        </div>
      </section>
      <footer
        style={{
          padding: "28px",
          textAlign: "center",
          color: "#78909a",
          fontSize: 13,
        }}
      >
        © MiBoard · <a href="/terms">Termos de uso</a> ·{" "}
        <a href="/privacy">Privacidade</a>
      </footer>
      {!cookieConsent && (
        <aside className="miboard-cookie-banner" aria-label="Preferências de cookies">
          <p>
            🍪 Usamos cookies essenciais para o funcionamento do MiBoard.
            <a href="/privacy"> Política de Privacidade e LGPD</a>
          </p>
          <div>
            <button type="button" onClick={() => saveCookieConsent("essential")}>
              Apenas essenciais
            </button>
            <button type="button" onClick={() => saveCookieConsent("all")}>
              Aceitar tudo
            </button>
          </div>
        </aside>
      )}
    </main>
  );
};
